const translations_eng = {
  "same.but": "Same but",
  different: "different",
  "whats.your.name": "What is your name?",
  "this.name.is.already.taken": "This name is already taken",
  "you.must.have.a.name": "You must have a name...",
  submit: "Submit",
  "how.to.play": "How to play",
  instructions:
    "The players come up with some categories together, for example ",
  "instructions.cont":
    'In each round a random letter will be chosen. Each player then tries to come up with a word for each category that starts with this letter. For the letter N for example you could write: Nigeria, New York, Narwhale, Nectarine. Depending on the game settings the round is over either when a player clicks the "DONE"-button or when the time limit is up. ',
  "category.example.1": "Country",
  "category.example.2": "City",
  "category.example.3": "Animal",
  "category.example.4": "Fruit/Vegetable",
  scoring: "Scoring",
  "scoring.instructions":
    "For each answer that begins with the correct letter and fits the category, you get 2 points. However, if another player answered the same both of you only get 1 point. So it is recommended to try and come up with unique answers! Invalid or empty answers give 0 points.",
  "scoring.example":
    "The scores can be changed manually after each round if the players agree that the automatic scoring is faulty. Here's an example of a round:",
  "scoring.example.explanation":
    "Green coloring means 2 point, blue means 1 point and red 0 points. The total score is shown at the bottom, with the scores gained the current round in paranthesis after the accumulated, total points.",
  close: "Close",
  game: "Game",
  join: "Join",
  "reconnect.as": "Reconnect as",
  "start.new.game": "Start new game",
  "include.swedish.letters": "Include ÅÄÖ",
  "include.hard.letters": "Include WXZQ",
  "play.with.time.limit": "Play with time limit",
  "win.conditions": "Win conditions:",
  none: " None",
  "number.of.rounds": " rounds",
  "number.of.points": " points",
  "players.can.end.round": "Players can end round",
  "you.must.enter.a.valid.time.limit": "You must enter a valid time limit!",
  "welcome.to.the.lobby.for.game": "WELCOME TO THE LOBBY FOR GAME",
  players: "Players",
  categories: "Categories",
  options: "Options",
  "add.another.category": "Add another category",
  "write.a.category": "Write a category",
  delete: "Delete",
  start: "Start",
  seconds: "seconds",
  "seconds.left": "s left",
  done: "Done",
  "total.points": "Total points",
  points: "points",
  ready: "Ready",
  "you.disconnected": "You disconnected!",
  "please.reload.page": "Please reload page",
  "remove.from.game": "Remove from game",
  "do.you.really.want.to.remove": (name: string) =>
    `Do you really want to remove ${name} from the game?`,
  "this.player": "this player",
  and: " and ",
  won: "won",
  "first.to": "First to",
  "no.hacking": "Stop trying to hack me!",
  "no.alex": "Do to recent attacks we no longer allow this name",
  "non.alpha.character": "You have entered a character that is not allowed",
  "name.too.long": "This name is too long",
};
export default translations_eng;
